export default __webpack_public_path__ + "static/lysicrates-mask-background-a1f1337a13fa67f368591e180292d900.jpg";